export default {
  title: 'Składka',
  type: 'object',
  properties: {
    name: {
      title: 'schema.fee.name',
      type: 'string',
      fieldRequired: true
    },
    price: {
      title: 'schema.fee.price',
      type: 'number',
      fieldRequired: true
    },
    teamId: {
      type: 'number',
      fieldRequired: false
    },
    clubId: {
      type: 'number',
      fieldRequired: false
    }
  }
};
